// extracted by mini-css-extract-plugin
export var localeSelector = "_9q-0";